import(/* webpackMode: "eager", webpackExports: ["Highlights"] */ "/workspace/src/components/blocks/Highlights.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GTMDataLayer"] */ "/workspace/src/components/GTMDataLayer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Schema"] */ "/workspace/src/components/Schema.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PlayerCareerStatsTable"] */ "/workspace/src/components/templates/Player/PlayerCareerStatsTable.js");
;
import(/* webpackMode: "eager", webpackExports: ["PlayerGameLogTable"] */ "/workspace/src/components/templates/Player/PlayerGameLogTable.js");
;
import(/* webpackMode: "eager", webpackExports: ["PlayerSplitsTable"] */ "/workspace/src/components/templates/Player/PlayerSplitsTable.js");
;
import(/* webpackMode: "eager", webpackExports: ["PlayerTransactionsTable"] */ "/workspace/src/components/templates/Player/PlayerTransactionsTable.js");
